var myFilterNames = new Array();
var myFilterValues = new Array();
var myProducts = new Array();

//unused
var filterCategories;
var filterCount = new Array();

productsShownWIthFilter = new Array();

var init = false;

var myProductHere;
var myFilterHere;

var showThisProduct = new Array();

var myTags = new Array();

var myProductValues = [];
var numberOfProductsTotal;
var numberOfProductsLeft;

myFilterNames[0] = "bottle";
myFilterNames[1] = "lid";
myFilterNames[2] = "tin";
myFilterNames[3] = "film";
myFilterNames[4] = "pet";
myFilterNames[5] = "glass";
myFilterNames[6] = "round";
myFilterNames[7] = "square";
myFilterNames[8] = "rectangular";
myFilterNames[9] = "retail";
myFilterNames[10] = "foodservice";
myFilterNames[11] = "industrial";
myFilterNames[12] = "handled";
myFilterNames[13] = "gripped";

myFilterValues[0] = 0;
myFilterValues[1] = 0;
myFilterValues[2] = 0;
myFilterValues[3] = 0;
myFilterValues[4] = 0;
myFilterValues[5] = 0;
myFilterValues[6] = 0;
myFilterValues[7] = 0;
myFilterValues[8] = 0;
myFilterValues[9] = 0;
myFilterValues[10] = 0;
myFilterValues[11] = 0;
myFilterValues[12] = 0;
myFilterValues[13] = 0;

function turnFilterOn(filterSent) { //turn on filter
    document.getElementById("filter-" + myFilterNames[filterSent]).style.color = "#ffffff";
    document.getElementById("filter-" + myFilterNames[filterSent]).style.backgroundColor = "#cccccc";
}

function turnFilterOff(filterSent) { //turn off filter
    document.getElementById("filter-" + myFilterNames[filterSent]).style.color = "";
    document.getElementById("filter-" + myFilterNames[filterSent]).style.backgroundColor = "";
}

function setupProductValues(){
  myProducts = document.getElementsByClassName("customizable-box-item"); //make array of all product divs
  numberOfProductsTotal = myProducts.length;
  
  for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product

    //showThisProduct[myProductHere] = 1; //all products initially showing
    
    myTags[myProductHere] = myProducts[myProductHere].dataset.product.toLowerCase(); //handledpetround
    
    myProductValues[myProductHere] = []; //set up stacked array for filter categories

    myProductValues[myProductHere][1] = []; //set up stacked array for Packaging Type    
    for (myFilterHere = 0; myFilterHere <= 3; myFilterHere += 1) { //for each filter 0–3      
      if (myTags[myProductHere].includes(myFilterNames[myFilterHere])) { //if any filternames are in the tags list included becomes 1
        myProductValues[myProductHere][1][myFilterHere] = 1;
      } else {
        myProductValues[myProductHere][1][myFilterHere] = 0;
      }
      //console.log(myFilterNames[myFilterHere] + " " + myProductValues[myProductHere][1][myFilterHere]);
    }
    
    myProductValues[myProductHere][2] = []; //set up stacked array for Materials    
    for (myFilterHere = 4; myFilterHere <= 5; myFilterHere += 1) { //for each filter 4–5      
      if (myTags[myProductHere].includes(myFilterNames[myFilterHere])) { //if any filternames are in the tags list included becomes 1
        myProductValues[myProductHere][2][myFilterHere] = 1;
      } else {
        myProductValues[myProductHere][2][myFilterHere] = 0;
      }
      //console.log(myFilterNames[myFilterHere] + " " + myProductValues[myProductHere][1][myFilterHere]);
    }

    myProductValues[myProductHere][3] = []; //set up stacked array for Shape    
    for (myFilterHere = 6; myFilterHere <= 8; myFilterHere += 1) { //for each filter 6–8     
      if (myTags[myProductHere].includes(myFilterNames[myFilterHere])){ //if any filternames are in the tags list included becomes 1
        myProductValues[myProductHere][3][myFilterHere] = 1;
      } else {
        myProductValues[myProductHere][3][myFilterHere] = 0;
      }
      //console.log(myFilterNames[myFilterHere] + " " + myProductValues[myProductHere][2][myFilterHere]);
    }

    myProductValues[myProductHere][4] = []; //set up stacked array for Market Category    
    for (myFilterHere = 9; myFilterHere <= 11; myFilterHere += 1) { //for each filter 9–11      
      if (myTags[myProductHere].includes(myFilterNames[myFilterHere])){ //if any filternames are in the tags list included becomes 1
        myProductValues[myProductHere][4][myFilterHere] = 1;
      } else {
        myProductValues[myProductHere][4][myFilterHere] = 0;
      }
      //console.log(myFilterNames[myFilterHere] + " " + myProductValues[myProductHere][3][myFilterHere]);
    }
    
    myProductValues[myProductHere][5] = []; //set up stacked array for Misc    
    for (myFilterHere = 12; myFilterHere <= 13; myFilterHere += 1) { //for each filter 12–13      
      if (myTags[myProductHere].includes(myFilterNames[myFilterHere])) { //if any filternames are in the tags list included becomes 1
        myProductValues[myProductHere][5][myFilterHere] = 1;
      } else {
        myProductValues[myProductHere][5][myFilterHere] = 0;
      }
      //console.log(myFilterNames[myFilterHere] + " " + myProductValues[myProductHere][4][myFilterHere]);
    }
  }
}

function interpretFilters(){
  //location.hash = "#scrollto-collection";
  numberOfProductsLeft = numberOfProductsTotal;
  
  for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–
    myProducts[myProductHere].parentNode.parentNode.style.display = "inline-block";
  }
  for (myFilterHere = 0; myFilterHere <= 3; myFilterHere +=1) { //for each filter Packaging Type
    if(myFilterValues[myFilterHere] == 1){
      for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–
        if(myProductValues[myProductHere][1][myFilterHere] == 0){
          if(myProducts[myProductHere].parentNode.parentNode.style.display == "inline-block"){
            myProducts[myProductHere].parentNode.parentNode.style.display = "none";
            numberOfProductsLeft --;
          }
        }
      }
    }
  }
  for (myFilterHere = 4; myFilterHere <= 5; myFilterHere +=1) { //for each filter Material
    if(myFilterValues[myFilterHere] == 1){
      for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–
        if(myProductValues[myProductHere][2][myFilterHere] == 0){
          if(myProducts[myProductHere].parentNode.parentNode.style.display == "inline-block"){
            myProducts[myProductHere].parentNode.parentNode.style.display = "none";
            numberOfProductsLeft --;
          }
        }
      }
    }
  }
  for (myFilterHere = 6; myFilterHere <= 8; myFilterHere +=1) { //for each filter Shape 
    if(myFilterValues[myFilterHere] == 1){
      for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–
        if(myProductValues[myProductHere][3][myFilterHere] == 0){
          if(myProducts[myProductHere].parentNode.parentNode.style.display == "inline-block"){
            myProducts[myProductHere].parentNode.parentNode.style.display = "none";
            numberOfProductsLeft --;
          }
        }
      }
    }
  }
  for (myFilterHere = 9; myFilterHere <= 11; myFilterHere +=1) { //for each filter Market Category
    if(myFilterValues[myFilterHere] == 1){
      for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–
        if(myProductValues[myProductHere][4][myFilterHere] == 0){
          if(myProducts[myProductHere].parentNode.parentNode.style.display == "inline-block"){
            myProducts[myProductHere].parentNode.parentNode.style.display = "none";
            numberOfProductsLeft --;
          }
        }
      }
    }
  }
  for (myFilterHere = 12; myFilterHere <= 13; myFilterHere += 1) { //for each filter Misc 
    if(myFilterValues[myFilterHere] == 1){
      for(myProductHere = 0; myProductHere < myProducts.length; myProductHere++) { //for each product 0–2 (3)
        if(myProductValues[myProductHere][5][myFilterHere] == 0){
          if(myProducts[myProductHere].parentNode.parentNode.style.display == "inline-block"){
            myProducts[myProductHere].parentNode.parentNode.style.display = "none";
            numberOfProductsLeft --;
          }
        }
      }
    }
  }
  
  var numberOfProductsShown = document.getElementsByClassName("filters-toolbar__product-count");
  if(numberOfProductsLeft == 1){
    numberOfProductsShown[0].innerHTML = numberOfProductsLeft + " product";
  } else {
    numberOfProductsShown[0].innerHTML = numberOfProductsLeft + " products";
  }
}

function countFilters(){ //returns number of filter categories as well as number of filters in each category
  var filterCategories = document.getElementById("filter-list").children;
  var ulNodes = [];
  var liNodes = [];
  
  for (var i = 0; i < filterCategories.length; i++) {
      if (filterCategories[i].nodeName == "UL") {
        ulNodes = filterCategories[i];
        liNodes.push(filterCategories[i].children);
      }
  }
  //console.log("0= " + liNodes[0].length);
  //console.log("1= " + liNodes[1].length);
  //console.log("2= " + liNodes[2].length);
}

function narrowFilterSelection(){ //gray out filters which no results contain 
  //console.log(" ");
  var allProductsOnPage = document.getElementsByClassName("customizable-box-item");
  var myTagsOfVisible = [];
  var tagsIncluded = [];
  var tagsNotIncluded = [];
  
  for(i = 0; i < allProductsOnPage.length; i ++){
    if(allProductsOnPage[i].parentNode.parentNode.style.display == "inline-block"){
      myTagsOfVisible.push(allProductsOnPage[i].dataset.product.toLowerCase()); //handledpetround
      //console.log("allProductsOnPage = " + myTagsOfVisible);
    } else {
      //console.log("none");
    }
  }
  
  for(i = 0; i < myTagsOfVisible.length; i++){ //get all tags of all visible products as array keys
    tagsIncluded[i] = []; //stack array
    tagsNotIncluded[i] = []; //stack array
    for(j = 0; j < myFilterNames.length; j++){ //check each filter
      if(myTagsOfVisible[i].includes(myFilterNames[j])){
        tagsIncluded[i].push(myFilterNames[j]);
        //console.log("Filters Included = " + myFilterNames[j]);
      } else {
        //console.log("Filters Not Included = " + myFilterNames[j]);
        tagsNotIncluded[i].push(myFilterNames[j]);
      }
    }
  }

  for(i = 0; i < tagsIncluded.length; i ++){
    for(j = 0; j < tagsIncluded[i].length; j ++){
      //console.log("Filters Included = " + tagsIncluded[i][j]);
      document.getElementById("filter-" + tagsIncluded[i][j]).style.color = "";
      document.getElementById("filter-" + tagsIncluded[i][j]).style.cursor = "pointer";
      for(k = 0; k < myFilterNames.length; k ++){
        if(tagsIncluded[i][j] == myFilterNames[k]){
          document.getElementById("filter-" + tagsIncluded[i][j]).setAttribute('onclick','filterClick(' + k + ');');
          //console.log("filterClick(" + k + ");");
          //console.log(" ");
        }
      }
    }
  }
  
  //console.log("allProductsOnPage = " + myTagsOfVisible.length);

  var tagsNotIncludedInAny = tagsNotIncluded.shift().reduce(function(res, v) { //return arrray that includes only tags that are not included in any shown product
      if (res.indexOf(v) === -1 && tagsNotIncluded.every(function(a) {
          return a.indexOf(v) !== -1;
      })) res.push(v);
      return res;
  }, []);
  //console.log("tagsNotIncludedInAny = " + tagsNotIncludedInAny);
  
  for(i = 0; i < tagsNotIncludedInAny.length; i++){
    document.getElementById("filter-" + tagsNotIncludedInAny[i]).onclick = "";
    document.getElementById("filter-" + tagsNotIncludedInAny[i]).style.cursor = "default";
    document.getElementById("filter-" + tagsNotIncludedInAny[i]).style.color = "#cccccc";
  }
}
function clearAllFilters(){
  for(i = 0; i < myFilterValues.length; i ++){
      myFilterValues[i] = 0;
      turnFilterOff(i); //turn off filter
  }
}

function filterClick(filterSent) { //from any filter button, filterSent = 0–6
  if (myFilterValues[filterSent] == 0) { //all are 0 initially
      myFilterValues[filterSent] = 1;
      turnFilterOn(filterSent); //turn on filter
  } else { //filter is already turned on
      myFilterValues[filterSent] = 0;
      turnFilterOff(filterSent); //turn off filter
  }
  if (init == false) {
    init = true;
    setupProductValues(filterSent);
  }
  interpretFilters();
  narrowFilterSelection();

  //clear url so scroll to transition works
  const url = new URL(window.location);
  url.hash = '#foo';
  window.history.pushState({}, '', url);
  
  document.location.hash="scrollto-collection"; //scroll to "#scrollto_collection
  
}




